module.exports = __webpack_public_path__ + "static/media/Hell Yeah - Instrumental Version.6dfbe2c0.jpg";